// extracted by mini-css-extract-plugin
export default {"expandIcon":"styles_expand-icon__cKV1w","content":"styles_content__3uR8s"};